const toEnglishDigits = (value) => {
    if (!value) return "";

    return value
        // Persian digits
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
        // Arabic digits
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
};

const UsersSearch = ({ value, onChange }) => {

    const handleChange = (e) => {
        const rawValue = e.target.value;
        const normalizedValue = toEnglishDigits(rawValue);
        onChange(normalizedValue);
    };

    return (
        <div className="bg-white p-4 rounded-xl shadow">
            <input
                value={value}
                onChange={handleChange}
                placeholder="جستجو با نام، نام خانوادگی، شماره یا ساعت..."
                className="
                    w-full px-4 py-3 rounded-lg border
                    outline-none border-slate-300 focus:ring-2
                    focus:ring-purple-400
                "
            />
        </div>
    );
};

export default UsersSearch;
